import { USER_AUDIT_TRAIL } from '@verify/shared-utils';
import { UserRolesData } from 'types';
import { isUserPrimaryRoleSelected } from 'pages/MyAccount/myTeam/auditTrailPermission';

// Audit trail is only granted on top of the User primary role; mirrors getAdditionalPermissionsForRole in the API.
export const getAdditionalRoles = (
  roleId: string | undefined,
  hasAuditTrail: boolean | undefined,
  roles: UserRolesData[] = [],
): string[] => (hasAuditTrail && isUserPrimaryRoleSelected(roleId, roles) ? [USER_AUDIT_TRAIL] : []);
